import React from 'react';

import useHasChromeExtension from 'src/hooks/useHasChromeExtension';

import GreenhouseHarvestV3Dialog from '../GreenhouseHarvestV3Dialog';

import ContractEndDateBanner from './ContractEndBanner';
import GreenhouseHarvestV3Banner from './GreenhouseHarvestV3Banner';
import ImpersonatingUserBanner from './ImpersonatingUserBanner';
import IntegrationHealthCheckBanners from './IntegrationHealthCheckBanners';
import LaunchDarklyBanner from './LaunchDarklyBanner';
import StatusPageBanner from './StatusPageBanner';
import MicrosoftIntegrationExpirationBanners from './MicrosoftIntegrationExpirationBanners';
import MissingChromeExtensionBanner from './MissingChromeExtensionBanner';
import MissingOrgAdminUserBanner from './MissingOrgAdminUserBanner';

const Banners: React.FC = (): JSX.Element => {
  const chrome = useHasChromeExtension();

  return (
    <>
      <ContractEndDateBanner />
      <LaunchDarklyBanner />
      <StatusPageBanner />
      <IntegrationHealthCheckBanners />
      <MicrosoftIntegrationExpirationBanners />
      <ImpersonatingUserBanner />
      <MissingOrgAdminUserBanner />
      {!chrome.hasExtension && (
        <MissingChromeExtensionBanner text={chrome.extensionBannerText} bannerUrlText={chrome.extensionBannerUrlText} />
      )}
      <GreenhouseHarvestV3Banner />
      <GreenhouseHarvestV3Dialog />
    </>
  );
};

export default Banners;
